import Content from "./content";
import { firmStats } from "~/util/review";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

function formatDate(dateFrom, dateTo) {
	const today = new Date().getTime();
	const day = 86400000;
	const paragraph = node("p");

	// jeste neplati
	if (today < dateFrom) {
		const days = Math.ceil((dateFrom - today) / day);

		if (days > 1) {
			paragraph.innerHTML = _("detail.content.leaflets.startsInXDays", { days: days });
		} else {
			paragraph.innerHTML = _("detail.content.leaflets.startsTomorrow");
		}
	} else {
		const days = Math.ceil((dateTo - today) / day);

		if (days === 0) {
			paragraph.innerHTML = _("detail.content.leaflets.endsToday");
			paragraph.classList.add("today");
		} else if (days === 1) {
			paragraph.innerHTML = _("detail.content.leaflets.endsTomorrow");
		} else {
			paragraph.innerHTML = _("detail.content.leaflets.endsInXDays", { days: days + 1 });
		}
	}

	return paragraph;
}

export default class Leaflets extends Content {
	_build() {
		this._dom.container.classList.add("content-leaflets");

		if (!this._data.length || !this._data[0].items || !this._data[0].items.length) {
			return;
		}

		Mapy.getComponent("logger").log("leaflet_kupi_show", {
			source: this._options.source,
			id: this._options.id,
			typeid: this._options.typeid,
			count: this._data[0].items.length,
		});

		// mame jen jeden letak
		if (this._data[0].items.length === 1) {
			this._dom.container.appendChild(this._buildItem(this._data[0].items[0], 0));
		// vic letaku, budeme delat fake a pak otevirat
		} else {
			// sestavime lakadlo
			this._dom.teaser = this._buildItem({
				imageUrl: this._data[0].items[0].imageUrl,
				title: _("detail.content.leaflets.actual"),
			});
			this._dom.container.appendChild(this._dom.teaser);

			// sestavime seznam, co budeme zobrazovat a schovavat
			this._dom.list = node("div", { className: "list hidden" });
			this._data[0].items.forEach((item, index) => {
				if (index < 3) {
					this._dom.list.appendChild(this._buildItem(item, index));
				}
			});
			this._dom.container.appendChild(this._dom.list);

			// tlacitko na otevirani/zavirani seznamu
			const button = node("button", { type: "button" });

			button.appendChild(icon("dropdown"));
			button.addEventListener("click", this, false);
			button.setAttribute("data-log-text", "leafletKupiShow");
			button.setAttribute("data-log-id", this._options.id);
			button.setAttribute("data-log-source", this._options.source);
			button.setAttribute("data-log-typeid", this._options.typeid);
			this._dom.container.appendChild(button);
			this._dom.toggleButton = button;
		}
	}

	_buildItem(data, index?) {
		const item = node(data.detailUrl ? "a" : "div", { className: "item" });

		if (data.detailUrl) {
			(item as HTMLAnchorElement).href = data.detailUrl;
			(item as HTMLAnchorElement).target = "_blank";
			(item as HTMLAnchorElement).rel = "noopener noreferer";

			item.addEventListener("click", () => {
				firmStats("firmy-vizitka-akce", this._options.detailData, {
					placeId: 1,
					typeId: 5,
					id: this._options.id,
					name: this._options.title,
					source: this._options.source,
				});
			});
			item.setAttribute("data-log-text", "leafletKupi");
			item.setAttribute("data-log-id", this._options.id);
			item.setAttribute("data-log-source", this._options.source);
			item.setAttribute("data-log-typeid", this._options.typeid);
			item.setAttribute("data-log-index", index + 1);
		}

		// obrazek
		item.appendChild(node("img", { alt: "", src: data.imageUrl ? data.imageUrl : "/img/detail/ph-leaflet.svg", className: data.imageUrl ? "" : "ph" }));

		// nazev a trvani
		const div = node("div", { innerHTML: `<h4>${data.title}</h4>` });

		if (data.dateTo) {
			div.appendChild(formatDate(new Date(data.dateFrom).getTime(), new Date(data.dateTo).getTime()));
		}
		item.appendChild(div);

		return item;
	}

	handleEvent() {
		this._dom.teaser.classList.toggle("hidden");
		this._dom.list.classList.toggle("hidden");
		this._dom.toggleButton.classList.toggle("open");
		if (this._dom.toggleButton.classList.contains("open")) {
			this._dom.toggleButton.setAttribute("data-log-text", "leafletKupiHide");
		} else {
			this._dom.toggleButton.setAttribute("data-log-text", "leafletKupiShow");
		}
	}
}
